<script setup>
import SegmentationForm from '@frontJs/components/forms/projectManagement/sem/SegmentationForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, semSegmentation, semSegmentationTypes, productAttributes } =
    defineProps({
        tenant: {
            type: Object,
            required: true,
        },
        semSegmentation: {
            type: Object,
            required: false,
        },
        semSegmentationTypes: {
            type: Array,
            required: true,
        },
        productAttributes: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="semSegmentation">
            Mettre à jour la segmentation #{{ semSegmentation.id }} -
            Segmentations - SEM - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une segmentation - Segmentations - SEM - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="semSegmentation" :tenant-name="tenant.name">
        Gestion de projet - SEM - Segmentations - Mettre à jour la segmentation
        #{{ semSegmentation.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEM - Segmentations - Créer une segmentation
    </PageTitle>

    <SegmentationForm
        :tenant="tenant"
        :sem-segmentation="semSegmentation"
        :sem-segmentation-types="semSegmentationTypes"
        :product-attributes="productAttributes"
    />
</template>
